// Unit is in pixel
const WINDOW_BREAK_POINTS = {
  SM: 600,
  MD: 960,
  LG: 1264,
  XL: 1904,
}

export default () => {
  const width = window.innerWidth
    ? window.innerWidth
    : document.documentElement.clientWidth
    ? document.documentElement.clientWidth
    : document.body.offsetWidth
  const height = window.innerHeight
    ? window.innerHeight
    : document.documentElement.clientHeight
    ? document.documentElement.clientHeight
    : document.body.offsetHeight

  return {
    width,
    height,
    isMobile: width < WINDOW_BREAK_POINTS.SM,
    isTablet:
      width >= WINDOW_BREAK_POINTS.SM && width <= WINDOW_BREAK_POINTS.MD,
    isLandscapeMode: height < width && width < 800,
    isDesktop: width >= WINDOW_BREAK_POINTS.MD,
  }
}
